import React, { useEffect } from "react";
import CoversureLogo from "../../assets/svg/coversure-logo.svg";
import FailureWebLogo from "../../assets/svg/web-failure-otp.svg";
import FailureMobLogo from "../../assets/svg/mob-failure-otp.svg";
import { useNavigate } from "react-router-dom";
import ROUTE_PATH from "../../constant/route";
import { useSelector } from "react-redux";

const OtpFailure = () => {
  const navigate = useNavigate();
  const userData = useSelector((state: any) => state);
  const {
    prosure: { formDetail },
    home: { totalPrice },
  } = userData;
  useEffect(() => {
    if (Number(totalPrice) === 0) {
      navigate(ROUTE_PATH.HOME);
    } else if (Object.keys(formDetail)?.length === 0) {
      navigate(ROUTE_PATH.CUSTOMER_DETAILS);
    }
  }, []);
  
  return (
    <div className=" flex items-center justify-center w-[100%] h-[100vh] bg-bg-color-3 sm:bg-bg-color-5">
      <div className="bg-bg-color-3 py-[14px] px-[16px] sm:py-[60px] sm:px-[88px] sm:rounded-[30px] bg-bg-color-3 sm:shadow-custom-light">
        <div className="flex flex-col items-center justify-center sm:mb-[36px] mb-[24px]">
          <img
            src={CoversureLogo}
            alt="CoversureLogo"
            className="hidden sm:block h-[22px]"
          />
          <img
            src={FailureWebLogo}
            alt="FailureWebLogo"
            className="hidden sm:block h-[110px] mt-[72px] mb-[22px]"
          />
          <img
            src={FailureMobLogo}
            alt="FailureMobLogo"
            className="block sm:hidden h-[60px] mb-[11px]"
          />
          <div className="sm:text-[30px] text-[16px] sm:leading-[38px] leading-[20px] font-bold text-text-color-6 ">
            Oops!
          </div>
          <div className="sm:text-[30px] text-[16px] sm:leading-[38px] leading-[20px] font-bold text-text-color-6 ">
            OTP verification failed.
          </div>

          <div
            onClick={() => {
              navigate(ROUTE_PATH.VERIFY_OTP);
            }}
            className="sm:text-[18px] text-[12px] sm:leading-[38px] leading-[15px] font-bold text-text-color-2 mt-[10px] underline cursor-pointer"
          >
            Try again
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtpFailure;
